// import React from 'react';
// import { Chip } from '@mui/material';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import SaveAsIcon from '@mui/icons-material/SaveAs';


// // Definimos la interfaz para las props
// interface CellDraftBooleanProps {
//     isPublished: boolean; // Determina si está publicado o en reserva
//     isValid?: boolean; // Determina si es válido o no
//     publishedLabel?: string; // Etiqueta personalizada para "Publicado"
//     reservedLabel?: string; // Etiqueta personalizada para "Reserva"
// }

// export const CellDraftBoolean: React.FC<CellDraftBooleanProps> = ({
//     isPublished,
//     isValid = null,
//     publishedLabel = 'Publicado',
//     reservedLabel = 'Reserva',
// }) => {
//     let chipConfig;
//     if (isValid === null || isValid) {
//         // Estilos y configuración según el estado
//         chipConfig = isPublished
//             ? {
//                 icon: <CheckCircleIcon style={{ color: "#2196F3" }} />, // Azul
//                 label: publishedLabel,
//                 style: {
//                     borderColor: "#64B5F6",
//                     color: "#1565C0", // Azul oscuro
//                     backgroundColor: "#E3F2FD", // Azul claro suave
//                 },
//             }
//             : {
//                 icon: <AccessTimeIcon style={{ color: "#757575" }} />, // Estilo para reserva (Pending)
//                 label: reservedLabel,
//                 style: {
//                     borderColor: "#BDBDBD",
//                     color: "#757575",
//                     backgroundColor: "#EEEEEE",
//                 },
//             };
//     } else {
//         chipConfig = {
//             icon: <SaveAsIcon style={{ color: "#FFC107" }} />, // Estilo para reserva (Pending)
//             label: "Pendiente",
//             style: {
//             borderColor: "#FFECB3",
//             color: "#FFA000",
//             backgroundColor: "#FFF8E1",
//             },
//         };
//     }

//     return (
//         <Chip
//             icon={chipConfig.icon}
//             label={chipConfig.label}
//             style={chipConfig.style}
//             size="small"
//             variant="outlined"
//         />
//     );
// };


import React from 'react';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SaveAsIcon from '@mui/icons-material/SaveAs';

// Definimos la interfaz para las props
interface CellDraftBooleanProps {
    isValid?: boolean; // Determina si es válido o no
}

export const CellDraftBoolean: React.FC<CellDraftBooleanProps> = ({
    isValid = null,
}) => {
    // Configuración de estilos y contenido
    const chipConfig = isValid
        ? {
              icon: <CheckCircleIcon style={{ color: "#2196F3" }} />, // Azul para "Activo"
              label: "Activo",
              style: {
                  borderColor: "#64B5F6",
                  color: "#1565C0", // Azul oscuro
                  backgroundColor: "#E3F2FD", // Azul claro suave
              },
          }
        : {
              icon: <SaveAsIcon style={{ color: "#FFC107" }} />, // Amarillo para "Reserva"
              label: "Reserva",
              style: {
                  borderColor: "#FFECB3",
                  color: "#FFA000",
                  backgroundColor: "#FFF8E1",
              },
          };

    return (
        <Chip
            icon={chipConfig.icon}
            label={chipConfig.label}
            style={chipConfig.style}
            size="small"
            variant="outlined"
        />
    );
};
